/** @jsxImportSource @emotion/react */
import * as React from 'react';
import { css, SerializedStyles } from '@emotion/react';
import { Side } from '../layout/position/side';
import { isVerticalSide } from '../layout/position/position';


const makeHorizClearBorders = (sizePx: number) => css`
  border-left: ${sizePx}px solid transparent;
  border-right: ${sizePx}px solid transparent;
`;


const makeVertClearBorders = (sizePx: number) => css`
  border-top: ${sizePx}px solid transparent;
  border-bottom: ${sizePx}px solid transparent;
`;


const makeArrowStyle = (position: Side, sizePx: number, color: string) => css`
  width: 0; 
  height: 0; 
  ${isVerticalSide(position) ? makeHorizClearBorders(sizePx) : makeVertClearBorders(sizePx)};
  border-${position}: ${sizePx}px solid ${color};
`;


/**
 * Arrow: a component that renders a div that looks like an arrow with the given color, size and on the given side.
 * Takes an optional css, but be aware that the arrow renders as a border -- messing with borders will likely
 * mess with the arrow.
 *
 * PureComponent: true
 * Connected to Redux: false
 */
export default class Arrow extends React.PureComponent<{
  side: Side;
  sizePx: number;
  color: string;
  rootCss?: SerializedStyles;
}> {
  public render = () => (
    <div
      css={css`
        ${makeArrowStyle(this.props.side, this.props.sizePx, this.props.color)};
        ${this.props.rootCss};
      `}
    />
  );
}
